import React from 'react'

export default function Details() {
 
  return (
    <>
    <div id="about" className="details-container">

        <p className="details-about-me">About Me</p>
        
       <p className="aboutme-summary">I am a <span className="aboutme-curious">curious</span>, <span className="aboutme-diligent">diligent</span>, and <span className="aboutme-analytical">analytical</span> software engineer who is passionate about building technologies to unite community. I merge my interdisciplinary experience in <span className="aboutme-data-science">data science</span> and <span className="aboutme-full">full-stack development</span> to analyze trends in technology and build performant websites and applications that enable users to achieve their goals.</p> 
      
      </div>
      </>
  )
}
